export const logos = {
	fullBlack: "/images/logos/blackadder-logo-full-b.svg",
	fullWhite: "/images/logos/blackadder-logo-full-w.svg",
	iconApp: "/images/logos/blackadder-logo-icon-app.png",
	iconAppStroke: "/images/logos/blackadder-logo-icon-app-stroke.png",
	icon: "/images/logos/blackadder-logo-icon.png",
	ticket: "/images/logos/blackadder-ticket.svg",
} as const;

export type LogoKey = keyof typeof logos;

export default logos;
